import request from "@/utils/request";

//1,查询单个参赛作品
export function getWorkDetail(data){
    return request({
        url:'/admin/getWorkDetail',
        data:data,
        method:'get'
    })
}
//2,查询参数作品列表 管理员
export function getWorks(data){
    return request({
        url:'/admin/getWorks',
        data:data,
        method:'get'
    })
}

//1，学生自己查看
export function getWorkDetailStudent(data){
    return request({
        url:'/team/getWork',
        data:data,
        method:'get'
    })
}
